<div class="vdd-selection-container">
  <div class="flex flex-row justify-between items-start">
    <h2>{{ 'GENERAL.BUTTON.ADD_PARAMETER' | translate }}</h2>
    <mat-icon (click)="dialogRef.close()">close</mat-icon>
  </div>
  <div class="flex flex-col">
    <mat-form-field mat-select-height-large class="control-unit-dropdown">
      <mat-label>{{ 'DIAGNOSTICS.CONTROL_UNIT' | translate }}</mat-label>
      <mat-select
        data-at-remote-diagnostics-control-unit-dropdown
        gtm="onOpen"
        gtmAction="Open control unit dropdown"
        gtmCategory="diagnosticsPage"
        (selectionChange)="onControlUnitOptionChange($event.value)"
        [disabled]="remoteDiagnosticsStore.isAnyParameterRunning(gatewaySerial) | async"
        [value]="currentControlUnit"
        [compareWith]="compareControlUnits"
        fieldTextContentTooltip
      >
        <mat-option
          *ngFor="let controlUnit of remoteDiagnosticsStore.getControlUnits(gatewaySerial) | async"
          [value]="controlUnit"
          gtm="onSelect"
          gtmAction="Control unit: '{{ controlUnit.value }}'"
          gtmCategory="diagnosticsPageHeader"
          [attr.data-at-control-unit]="controlUnit.value"
          fieldTextContentTooltip
          >{{ controlUnit.objectProperty | translate }} {{ controlUnit.busType | translate }}:
          {{ remoteDiagnosticsMappers.getBusAddressOfLogicalLink(controlUnit) }}</mat-option
        >
      </mat-select>
    </mat-form-field>
    <div class="flex flex-row justify-center items-center">
      <mat-spinner
        *ngIf="
          (remoteDiagnosticsStore.selectLogicalLinkOpenLoading$ | async) ||
          (remoteDiagnosticsStore.selectVddListLoading$ | async)
        "
      ></mat-spinner>
    </div>
    <vi-dropdown-autocomplete-multiselect
      *ngIf="
        !(remoteDiagnosticsStore.loading$ | async) &&
        !(remoteDiagnosticsStore.selectLogicalLinkOpenLoading$ | async) &&
        !(remoteDiagnosticsStore.selectVddListLoading$ | async) &&
        availableParametersExceptSelected?.length &&
        currentControlUnit
      "
      data-at-remote-diagnostics-parameter-name-dropdown
      placeholder="{{ 'DIAGNOSTICS.PARAMETER' | translate }}"
      unselectMessageKey="DIAGNOSTICS.SELECTED_OF"
      [options]="availableParametersExceptSelected"
      [elementHeight]="remoteDiagnosticsUiService.virtualScrollElementHeight$ | async"
      (optionChange)="addParameters($event)"
    ></vi-dropdown-autocomplete-multiselect>
    <span class="selected-of">
      {{
        selectedVdds.length
          ? ('DIAGNOSTICS.SELECTED_OF'
            | translate
              : {
                  selectedParams: selectedVdds.length,
                  allParams: availableParametersExceptSelected.length
                })
          : ('+DIAGNOSTICS.NO_SELECTED' | translate)
      }}
    </span>
    <button
      (click)="closeModal()"
      *ngIf="!loading"
      mat-raised-button
      color="primary"
      [disabled]="!selectedVdds.length"
    >
      <span>
        {{ 'DIAGNOSTICS.ACCEPT_SELECTION' | translate }}
      </span>
    </button>
    <vi-loader
      *ngIf="loading"
      [isLoading]="true"
      [message]="'+SEARCH.RESULT_LIST.LOADING' | translate"
    ></vi-loader>
  </div>
</div>
